import { selector } from 'recoil'
import { currentTokenState, otpSendState, refreshTokenCounter } from './atom'
import { currentUserState } from 'services/user'

export const isLoggedIn = selector({
  key: 'IsLoggedIn',
  get: ({ get }) => {
    const tokens = get(currentTokenState)
    const user = get(currentUserState)

    return tokens.access && user.id
  },
})

export const resetAuthState = selector<void>({
  key: 'resetAuthState',
  /* eslint-disable-next-line "prettier/prettier" */
  get: () => { },
  set: ({ reset }) => {
    reset(currentTokenState)
    reset(currentUserState)
    reset(otpSendState)
  },
})

export const incrementRefreshCounter = selector<boolean>({
  key: 'IncrementRefreshCounter',
  get: ({ get }) => get(refreshTokenCounter) >= 1,
  set: ({ get, set }, reset) => {
    const current = get(refreshTokenCounter)
    if (current < 1) {
      set(refreshTokenCounter, current + 1)
    }
    if (reset) {
      set(refreshTokenCounter, 0)
    }
  },
})
